import EnrollPatient from './EnrollPatient'
import ImportErrors from "./ImportErrors"
export default {
	EnrollPatient,
	ImportErrors
}
